export default {
  colors: {
    primary: "#46b5FF",
    danger: "#ea5455",
    grey: "#626262",
    primaryGradient: "linear-gradient(118deg, rgba(70, 181, 255, 1), rgba(70, 181, 255, 0.7))"
  },
  breakpoints: {
    sm: 480,
    md: 768,
    lg: 1024
  }
}
